import ApiService from "../../common/apiService";
import { getData } from "../../common/dataHelper";
import { CERTIFICATE_TYPES } from "../types";
const state = {
    certificate: null,
    coupons: [],
    courseCoupon: { code: "", value: "" },
};

const getters = {
    [CERTIFICATE_TYPES.GET_CERTIFICATE](state) {
        return state.certificate;
    },
    [CERTIFICATE_TYPES.GET_COUPONS](state) {
        return state.coupons;
    },
    [CERTIFICATE_TYPES.GET_COURSE_COUPON](state) {
        return state.courseCoupon;
    },
};

const actions = {
    async [CERTIFICATE_TYPES.FETCH_CERTIFICATE]({ commit }, { courseId }) {
        const response = await ApiService.query(
            `academy/courses/${courseId}/certificate`
        );
        const certificate = getData(response, "data");
        if (certificate && getData(response, "status") == 200) {
            commit(CERTIFICATE_TYPES.SET_CERTIFICATE, certificate);
        } else {
            commit(CERTIFICATE_TYPES.SET_CERTIFICATE, null);
        }
        return response;
    },
    async [CERTIFICATE_TYPES.DOWNLOAD_CERTIFICATE](context, { courseId }) {
        const route = `${process.env.VUE_APP_API_URL}/academy/courses/${courseId}/certificate?is_download=true`;
        var link = document.createElement("a");
        link.download = "zertifikat.pdf";
        link.href = route;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
    async [CERTIFICATE_TYPES.FETCH_COUPONS]({ commit }) {
        const response = await ApiService.query(`academy/coupons`);
        const coupons = getData(response, "data");
        if (coupons) {
            commit(CERTIFICATE_TYPES.SET_COUPONS, coupons);
        }
        return response;
    },
    async [CERTIFICATE_TYPES.FETCH_COURSE_COUPON]({ commit }, { courseId }) {
        const response = await ApiService.query(`academy/coupons`, {
            course_id: courseId,
        });
        const coupon = getData(response, "data");
        if (coupon) {
            commit(CERTIFICATE_TYPES.SET_COURSE_COUPON, coupon);
        }
        return response;
    },
};

const mutations = {
    [CERTIFICATE_TYPES.SET_CERTIFICATE](state, object) {
        state.certificate = object;
    },
    [CERTIFICATE_TYPES.SET_COUPONS](state, object) {
        state.coupons = object;
    },
    [CERTIFICATE_TYPES.SET_COURSE_COUPON](state, object) {
        state.courseCoupon = object;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
